<template>
  <div>
    <md-dialog :md-active.sync="showDialog" id="dialog">
        <md-card>
          <md-card-header style="padding:10px !important;">
            <md-card-header-text>
              <div class="md-title">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item v-center" style="padding-left:calc(2em)">Browse Reward</div>
                  <div class="md-layout-item" style="text-align:right">
                    <md-button class="md-icon-button" @click="closeDialog()">
                      <md-icon>close</md-icon>
                    </md-button>
                  </div>
                </div>
              </div>
            </md-card-header-text>
          </md-card-header>
          <md-card-content>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-5">
                &nbsp;
              </div>
              <div class="md-layout-item md-size-15" style="padding:0">
                <md-field>
                  <label>Search Reward</label>
                  <md-input v-model="searchText"></md-input>
                </md-field>
              </div>
            </div>
            <!-- <div class="displayItem md-scrollbar"> -->
            <md-content class="displayItem md-scrollbar" id="displayItem" v-if="list.length>0">
              <div class="elevation-demo" v-for="item in list" :key="item._id">
                <!-- <button > -->
                <md-content class="md-elevation-1" @click.native="activatedThis($event,item)" v-bind:class="{'active':isEqual(item._id)}" v-bind:id="item._id">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item image">
                      <img class="imgItem" :src="item.image">
                    </div>
                    <div class="md-layout-item alignRight" >
                      <div style="font-size:12px;color:#A8A8A8">Product Name</div>
                      <div style="font-size:16px">{{item.name}}</div>
                      <div style="font-size:12px;color:#A8A8A8">Product Value</div>
                      <div style="font-size:16px">{{item.value}}</div>
                      <div style="font-size:12px;color:#A8A8A8">In-Stock</div>
                      <div style="font-size:16px">{{item.in_stock}}</div>
                      <!-- <div style="font-size:12px;color:#A8A8A8">ESTIMATE COST</div>
                      <div style="font-size:16px">{{item.cost}}</div> -->
                    </div>
                  </div>
                  </md-content>
                <!-- </button> -->
              </div>
            </md-content>
            <md-content class="displayItem md-scrollbar" id="displayItem" v-if="list.length==0">
              <div style="font-size:16px;color:#A8A8A8">Found 0 item</div>
            </md-content>
            <!-- <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-66">&nbsp;</div>
              <div class="md-layout-item md-size-30"> -->
                  <!-- <div class="custom-picker"> -->
            <div style="float:right;">
              <div style="padding-right:30px;">
                <md-field :md-counter="false">
                  <label>Quantity</label>
                  <md-input v-model="qty" maxlength="4" @keydown="keyHandler($event,index)"></md-input>
                </md-field>
                <!-- <md-field :md-counter="false">
                    <label id="qt">Quantity</label>
                    <md-input type="number" v-model="qty" @keydown="keyHandler($event,index)" maxlength="3"></md-input>
                </md-field> -->
                  <md-datepicker v-model="selectedDate" md-immediately>
                    <label>Estimate Send Date</label>
                  </md-datepicker>
                </div>
                <div style="float:right">
                  <div>
                    <md-button style="color:#727272" @click="closeDialog()">CANCEL</md-button>
                    <md-button style="color:#3F51B5" @click="onConfirm()">ADD</md-button>
                  </div>
                </div>
              </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-70">&nbsp;</div>
              <div class="md-layout-item md-size-26" style="text-align:right">
              </div>
            </div>
            <!-- <div>
              <div class="action">
                <md-field>
                  <label id="qt">Quantity</label>
                  <md-input id="qtinput" v-model="qty"></md-input>
                </md-field>
              </div>
              <div>
                <div style="display:flex;">
                <div class="mdl">
                </div>
                <div class="custom-picker">
                  <md-datepicker id="esd" v-model="selectedDate" md-immediately>
                    <label id="esdlabel">Estimate Send Date</label>
                  </md-datepicker>
                </div>
                <div class="mdr">
                </div>
                </div>
              </div>
              <div class="actionBTN">
                    <md-button style="color:#727272" @click="closeDialog()">CANCEL</md-button>
                    <md-button style="color:#3F51B5" @click="onConfirm()">ADD</md-button>
              </div>
            </div> -->
          </md-card-content>
        </md-card>
        <!-- <md-tab md-label="B">
        </md-tab>
      </md-tabs>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false">Close</md-button>
        <md-button class="md-primary" @click="showDialog = false">Save</md-button>
      </md-dialog-actions> -->
    </md-dialog>
    <md-dialog-confirm
      :md-active.sync="validateDialog"
      md-title="Validation Warning!"
      md-content="Please input all of necessary."
      md-confirm-text="Confirm"
      @md-confirm="onConfirm" />

    <!-- <md-button class="md-primary md-raised" @click="validateDialog = false">Confirm</md-button> -->
  </div>
</template>

<script>

  import moment from 'moment-timezone';
  import RewardService from "@/services/reward";

  export default {
    name: 'DialogCustom',
    data: () => ({
      showDialog: false,
      validateDialog : false,
      searchText : '',
      selectedDate: null,
      id: null,
      selected: null,
      ListTemp : [],
      qty : null,
      esd : null,
      index : null,
      image : null,
      title : null,
      cost : null,
      rewardList: [],
      name: '',
      inStock: 0
    }),

    computed:{
      list() {
        return this.rewardList;
        // return this.rewardList.filter(data => {
        //   return data.title.toLowerCase().includes(this.searchText.toLowerCase())
        // })
      }
    },
    created(){
      RewardService.getAllRewardOwner().then(response =>{
        this.rewardList = response;
      });
    },
    methods:{
      closeDialog(){
        this.showDialog = false;
      },
      activatedThis(event,item){
        this.selected = event.currentTarget.id
        this.id = item._id
        this.image = item.image
        this.title = item.title
        this.cost = item.cost
        this.name = item.name
      },
      isEqual(id){
        if(id!=''){
          if(this.selected == id){
            return true;
          }else{
            return false;
          }
        }
      },
      onConfirm() {
        if(this.qty!=null && this.id!=null){
          this.save()
        }else{
          this.validateDialog = true
        }
      },
      save(){
          this.showDialog = false
          let data = {}
          data.qty = this.qty
          // let day,month,year
          // day = formatDate.getDate();
          // month = formatDate.getMonth();
          // year = formatDate.getFullYear();
          data.id = this.id
          if(this.selectedDate)
            data.sendDate = moment(this.selectedDate).format("YYYY-MM-DD");//.toISOString().slice(0,10)
          else 
            data.sendDate = null;
          // data.index = this.index
          data.image = this.image
          // data.title = this.title
          // data.cost = this.cost
          data.name = this.name
          this.$emit("addRewards",data)
          this.clearData();

      },
      clearData(){
          this.qty = null
          this.id = null
          this.selectedDate = null
          this.selected = null
      },
      keyHandler(e,index) {
        // console.log(e.keyCode)
        // if ([8, 49, 50, 51, 52, 53, 54, 55, 56, 57, 97, 98, 99, 100, 101, 102, 103, 104, 105].includes(e.keyCode)) {

        // }else{
        //   e.preventDefault();
        // }
      }
    }
  }
</script>

<style lang="scss" scoped>
#dialog{
	width: 995px;
}

#qt,#esd{
  left:auto;
}

#esdlabel{
  left:auto;
  right:0;
}

#qtinput,#esdinput{
  text-align: right;
  width: auto !important;
}
.md-datepicker-dialog{
  height: 50%;
}

.mdr{
  margin-right: calc(15%);
}

.mdl{
  margin-left: calc(70%);
}

.hideBTN{
  display: hide;
  background-color: #fff;
  border: 0pt;
  padding : 0 !important;
}

.active{
	// background-color: #C4C4C4 !important;
  border-style: solid;
  border-color: #3F51B5 !important;
}

.v-center{
    margin: auto;
}

.md-field{
  // left : ;
  right: 0 !important;
  .md-icon{
      display: none !important;
  }
}

.md-dialog{
  //  width: calc(80em);
  // max-width: 1000px !important;
  // height: 100% !important;
  // width: 995px !important;
  max-height: none !important;
  // height: 762px !important;
  .md-dialog-container{
    .md-card md-theme-default{
      width: 995px
    }
  }
  
}

.imgItem{
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10%;
  height: 100px !important;
  width: auto;
}

.image{
  width: 100px;
  padding : 0px !important;
}

.alignRight{
  text-align: right;
}

.md-field{
  margin:4px 0 10px !important;
}

input{
  .md-input{
    left:auto !important;
    right:0 !important;

  }
}

.md-card-header{
  padding-top: 19px;
  padding-bottom: 21px;
  background-color: #EFEFEF;
  line-height : 20px;
}

.md-title{
  line-height : 20px;
  margin: 0px !important;
  font-size: 20px !important;
}

// .md-card-content{
//   //   text-align: center;
//   //  padding: 0 !important;
// }

.action{
  // float: right;
  width: calc(245px);
  margin-left: calc(70%);
}

// #displayItem{
//   width:auto !important;
//   height:auto !important;
//   margin-top: 10px;
// }

.displayItem{
  width:auto !important;
  height:auto !important;
  display: flex;
  flex-wrap: wrap;
  margin-top: 50px;
  // float: right !important;
  // height: 400px;
  max-height: 400px;
  overflow: auto;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right:10px;

  .elevation-demo {
    // margin: 0px !important;
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .md-elevation-1{
      margin-top: 10px;
      margin-bottom: 10px;
      margin-left: 5px;
      margin-right:5px;
      width:290px !important;
      height:178px !important;
      justify-content: center;
    }

  }


}


.md-tabs-navigation{
  background-color: #EFEFEF;
}

.md-content {
  width: 100px;
  height: 100px;
  margin: 24px;
  display: flex;
  align-items: center;
}

.box-info{
	margin: 20px;
	background:white;
}
</style>